import type { SuburbInput } from "@repo/adapter-core";
import { slugify } from "@repo/adapter-core";
import type { PropertyComAuAdapterConfig } from "./config.ts";

const LISTING_TYPE_PATH_SEGMENT: Record<string, string> = {
  sold: "sold",
  buy: "buy",
  rent: "rent",
};

/**
 * property.com.au listing URLs are `{state}/{suburb}-{postcode}/{listingType}/`
 * — NOT `{listingType}/{state}/{suburb}-{postcode}/` which the earlier
 * code assumed. The wrong order returned "Oops, page not found!"
 * (verified 2026-05-20 via Brightdata Scraping Browser:
 * `/sold/qld/brisbane-city-4000` → 404; correct
 * `/qld/brisbane-city-4000/sold/` → 1,582 sold listings). Detail
 * urlPattern in meta.ts is unchanged and matches the per-property
 * pages this listing page links to.
 */
export function buildSearchUrl(suburb: SuburbInput, config: PropertyComAuAdapterConfig): string {
  const segment = LISTING_TYPE_PATH_SEGMENT[config.listingType] ?? LISTING_TYPE_PATH_SEGMENT.buy;
  return `https://www.property.com.au/${suburb.state.toLowerCase()}/${slugify(suburb.locality)}-${suburb.postcode}/${segment}/`;
}
